import {
  Customer_Payments,
  Customer_Payments_AmountLimits,
} from "data/endpoints";
import IRepository from "data/IRepository";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import CustomerState from "infrastructure/store/customer/CustomerState";
import IAppState from "infrastructure/store/IAppState";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Payment from "../components/Payment";
import PaymentHeader from "../components/PaymentHeader";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import AmountLimitDTO from "features/shared/dtos/AmountLimitDTO";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { loadDataFilterConfig } from "features/shared/helpers/modules";

const paymentsDataFilterJson = loadDataFilterConfig("paymentsDataFilter");

const PaymentsSection = () => {
  // DI
  const paymentAmountLimitsRepo = useInjection<IRepository<AmountLimitDTO>>(IocTypes.Repository);

  // STORE
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // STATE
  const [externalFilterData, setExternalFilterData] = useState<IExternalFilterData<any>[]>([]);

  // FUNCTIONS
  const getExternalFilterData = async () => {
    let externalFilterData: IExternalFilterData<any>[] = [];

    // Payment Amount Limits
    const paymentAmountLimits = await paymentAmountLimitsRepo.get({
      url: Customer_Payments_AmountLimits,
      routeParams: getRouteParams("customerId", customer.customerId!),
    });

    const currencyCodes = [
      ...new Set(paymentAmountLimits.map((x) => x.currencyCode)),
    ];

    externalFilterData.push({
      name: "CurrencyCode",
      data: currencyCodes.map((val) => {
        return { currencyCode: val };
      }),
    });

    externalFilterData.push({
      name: "Amount",
      data: paymentAmountLimits.filter((x) => x.limitType === "Amount"),
    });

    externalFilterData.push({
      name: "AmountUsed",
      data: paymentAmountLimits.filter((x) => x.limitType === "AmountUsed"),
    });

    // Nastavení
    setExternalFilterData(externalFilterData);
  };

  // Externí data pro filtr
  useEffect(() => {
    getExternalFilterData();
  }, []);

  // render
  return (
    <DataGrid 
      gridId={DataGridId.paymentGrid}
      url={Customer_Payments}
      filterJson={paymentsDataFilterJson}
      filterExternalData={externalFilterData}
      renderItem={(item) => <Payment payment={item} showInvoiceTimePeriod />}
      renderHeader={() => <PaymentHeader />}
    />
  );
};

export default PaymentsSection;
